import { axios } from "../../helpers/axios";
import { isAuth } from "../../helpers/cookies";

import {
    COMPANY_URL,
    USER_URL,
    GET_COMPANY_USERS_URL,
    CREATE_ACCOUNT,
    GET_COMPANY_PROCESS
} from "./accountConstants";

export const api_get_company_users_url = async (company_id, qc, qn, page, limit) => {
    return axios.get(`company/${company_id}/user`, { params: { qc, qn, page, limit } });
};


export const api_get_company_list_url = async (params) => {
    return axios.get(COMPANY_URL, { params });
};

export const api_create_account_url = async (data) => {
    const company_id = isAuth()?.company_id;
    return axios.post(`company/${company_id}/user`, data);
};

export const api_activate_deactivate_users_url = async (user_id, data) => {
    return axios.patch(COMPANY_URL + "/" + user_id + "/" + data);
};

export const api_get_user_details_url = async (user_id) => {
    const company_id = isAuth()?.company_id;
    return axios.get(`company/${company_id}/user/${user_id}`);
};

export const api_update_account_url = async (user_id, data) => {
    return axios.put(COMPANY_URL + USER_URL + '/' + user_id, data);
};


export const api_get_company_process_url = async () => {
    return axios.get(`${GET_COMPANY_PROCESS}`);
};